<template>
  <div id="powerupsContainer" class="page-container">
    <div class="page-content">
      <div class="flex-row-center mt-16">
        <img src="../assets/images/navbar/ic_power-ups.webp" class="icon-pages" />
        <span class="page-title">{{ $t("page.power_up") }}</span>
        <div class="page-des-line">
          <span class="page-des ml-10">{{
            $t("page.power_up_description")
          }}</span>
        </div>
      </div>

      <el-tabs
        class="style-bar"
        v-bind:value="activeName"
        @tab-click="forceRerender"
      >
        <el-tab-pane label="Create" name="create" default>
          <span slot="label" class="title-bar">{{ $t("page.create") }}</span>
          <create
            v-if="renderComponent == false && activeName == 'create'"
          ></create>
        </el-tab-pane>
        <el-tab-pane label="Outbox" name="outbox">
          <span slot="label" class="title-bar">{{ $t("page.outbox") }}</span>
          <outbox
            v-if="renderComponent == false && activeName == 'outbox'"
          ></outbox>
        </el-tab-pane>
        <el-tab-pane label="Activity" name="activity">
          <span slot="label" class="title-bar">{{ $t("page.activity") }}</span>
          <activity
            v-if="renderComponent == false && activeName == 'activity'"
          ></activity>
        </el-tab-pane>
        <el-tab-pane label="Leaderboards" name="leaderboards">
          <span slot="label" class="title-bar">{{ $t("page.leaderboards") }}</span>
          <leaderboards
            v-if="renderComponent == false && activeName == 'leaderboards'"
          ></leaderboards>
        </el-tab-pane>
        <el-tab-pane label="performance" name="performance">
          <span slot="label" class="title-bar">Performance</span>
          <performance
            v-if="renderComponent == false && activeName == 'performance'"
          ></performance>
        </el-tab-pane>
        <el-tab-pane v-if="this.companyData.show_integration && this.companyData.show_integration == 'Y'" label="Activity" name="integrations">
          <span slot="label" class="title-bar">{{
            $t("page.integrations")
          }}</span>
          <integrations
            v-if="renderComponent == false && activeName == 'integrations'"
          ></integrations>
        </el-tab-pane>
      </el-tabs>
      <component
        v-if="
          (activeName == 'create' ||
            activeName == 'outbox' ||
            activeName == 'activity' ||
            activeName == 'integrations'||
            activeName == 'leaderboards'||
            activeName =='performance') &&
          renderComponent
        "
        v-bind:is="activeName"
      ></component>
    </div>
  </div>
</template>

<script>
export default {
  name: "members",
  created() {
    this.$store.dispatch("powerups/getActiveTabs");
  },
  components: {
    create: require("./powerups/create").default,
    outbox: require("./powerups/outbox").default,
    activity: require("./powerups/activity").default,
    leaderboards: require("./powerups/leaderboards").default,
    integrations: require("./powerups/integrations").default,
    performance: require("./powerups/performance").default,
  },
  data() {
    return {
      anchor: {
        create: "create",
        outbox: "outbox",
        activity: "activity",
        integrations: "integrations",
        performance: "performance",
      },
    };
  },
  computed: {
    companyData() {
      return this.$store.getters["authen/companyData"];
    },
    activeName() {
      return this.$store.getters["powerups/activeName"];
    },
    renderComponent() {
      return this.$store.getters["powerups/renderComponent"];
    },
  },
  mounted() {
    const params = this.$router.currentRoute.params.tab;
    if (params && this.anchor[params]) {
      this.$store.commit("powerups/setActiveTabs", {
        activeName: params,
        renderComponent: false,
      });
    } else {
      this.$router.push({ name: "power-ups", params: { tab: "create" } });
    }
    this.$root.$on('changeTab', (item) => {
      if (item.path == "power-ups") {
        item.name = item.tab;
        this.forceRerender(item);
      }
    });
  },
  methods: {
    forceRerender(obj) {
      if (this.renderComponent == true) {
        this.$store.commit("powerups/setActiveTabs", {
          activeName: obj.name,
          renderComponent: false,
        });
      } else {
        this.$store.commit("powerups/setActiveTabs", {
          activeName: obj.name,
          renderComponent: true,
        });
      }
      this.$router.push({ name: "power-ups", params: { tab: obj.name } });
    },
  },
};
</script>

<style>
#powerupsContainer .el-tabs__item {
  height: 52px;
  line-height: 52px;
  width: 150px;
  text-align: center;
}
#powerupsContainer .el-tabs__header {
  margin: 0px;
}
</style>
